import { useRouter } from 'next/router'
import { useEffect, useMemo, useRef } from 'react'
import { stringifyUrl } from '@ucheba/utils/helpers/router'

interface IProps {
  pathname?: string
  skip?: boolean
}

interface IUseRedirectByQueryParams {
  (extra?: IProps): void
}

/* Редирект при изменения урла */
export const useRedirectByQueryParams: IUseRedirectByQueryParams = (props) => {
  const { pathname, skip } = props || {}
  const { query, push } = useRouter()
  const renderCount = useRef<number>(0)
  const lastQuery = useRef<Record<string, any>>(query)

  const newQuery = useMemo(() => {
    if (query) {
      const obj = {}

      Object.keys(query).forEach((key) => {
        if (key !== 'params') {
          const facetName = key.replace(/[[]]/gm, '')

          if (key.includes('[]')) {
            obj[facetName] = Array.isArray(query[key]) ? query[key] : [query[key]]
          } else {
            obj[facetName] = query[key]
          }
        }
      })

      return obj
    }

    return {}
  }, [query])

  useEffect(() => {
    if (skip) return
    if (
      pathname &&
      renderCount.current >= 1 &&
      JSON.stringify(newQuery) !== JSON.stringify(lastQuery.current)
    ) {
      push(
        stringifyUrl(pathname, {
          set: {
            ...newQuery,
          },
        })
      )
    }

    lastQuery.current = newQuery
    ++renderCount.current
  }, [newQuery, skip])
}
